import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import styles from './HomeIdentityBar.module.css';
import { FoundingCollectorIcon } from '../FoundingCollectorBadge/FoundingCollectorBadge';

const TIERS = [
    { name: 'Newcomer',   min: 0,   max: 9,   ring: '#888' },
    { name: 'Verified',   min: 10,  max: 24,  ring: '#8B5E3C' },
    { name: 'Collector',  min: 25,  max: 49,  ring: '#A8B0B8' },
    { name: 'Curator',    min: 50,  max: 99,  ring: '#C8A84B' },
    { name: 'Archivist',  min: 100, max: 999, ring: '#7B1FA2' },
];

function getTierInfo(coinCount = 0, legendaryCount = 0) {
    if (legendaryCount >= 3) return { name: 'Legendary', ring: '#FFD700', isLegendary: true };
    return TIERS.find(t => coinCount >= t.min && coinCount <= t.max) || TIERS[0];
}

export default function HomeIdentityBar({ profile, coins, loading }) {
    const coinCount     = profile?.stats?.badgeCount ?? 0;
    const legendaryCount = useMemo(() => (coins || []).filter(c => c.rarity === 'legendary').length, [coins]);
    const tier          = getTierInfo(coinCount, legendaryCount);
    const streak        = profile?.streak ?? 0;

    const currentTierIdx = TIERS.findIndex(t => t.name === tier.name);
    const nextTier       = TIERS[currentTierIdx + 1];
    const progressPct    = nextTier
        ? Math.min(100, Math.max(0, Math.round(((coinCount - (TIERS[currentTierIdx]?.min ?? 0)) / ((nextTier.min) - (TIERS[currentTierIdx]?.min ?? 0))) * 100)))
        : 100;

    if (loading) return <div className={styles.barSkeleton} />;

    return (
        <header className={styles.bar}>
            <div className={styles.inner}>
                <div className={styles.left}>
                    <Link to="/me" className={styles.avatarWrap} style={{ '--ring': tier.ring }}>
                        {profile?.avatar_url
                            ? <img src={profile.avatar_url} alt="avatar" className={styles.avatar} />
                            : <div className={styles.avatarFallback}>{(profile?.display_name || profile?.username || '?')[0].toUpperCase()}</div>
                        }
                        {tier.isLegendary && <span className={styles.legendaryPulse} />}
                    </Link>
                    <div className={styles.identity}>
                        <span className={styles.username}>
                            @{profile?.username}
                            <FoundingCollectorIcon isFoundingCollector={profile?.isFoundingCollector} />
                        </span>
                        <div className={styles.tierRow}>
                            {/*<span className={styles.tierBadge} style={{ color: tier.ring }}>{tier.name.toUpperCase()}</span>*/}
                            {/*<span className={styles.dot}>·</span>*/}
                            <span className={styles.coinCount}>{coinCount} coins</span>
                            {legendaryCount > 0 && <span className={styles.legendary}>✦ {legendaryCount}L</span>}
                        </div>
                        {/*<div className={styles.progressTrack}>*/}
                        {/*    <div*/}
                        {/*        className={styles.progressFill}*/}
                        {/*        style={{ width: `${progressPct}%`, background: tier.ring }}*/}
                        {/*    />*/}
                        {/*</div>*/}
                        {/*{nextTier && <span className={styles.nextTier}>{Math.max(0, nextTier.min - coinCount)} to {nextTier.name}</span>}*/}
                    </div>
                </div>

                <div className={styles.right}>
                    {streak > 0 && (
                        <div className={styles.streak}>
                            <span className={styles.streakFlame}>🔥</span>
                            <span className={styles.streakCount}>{streak}</span>
                            <span className={styles.streakLabel}>day streak</span>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
}
